import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "28",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.829 25.142c-6.612 0-11.971-5.36-11.971-11.971S7.218 1.2 13.828 1.2C20.44 1.2 25.8 6.56 25.8 13.17s-5.36 11.971-11.971 11.971M5.503 22.119.81 26.8",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }